/** Coerces API and chart values into a finite number. */
export function parseLocaleNumber(value: unknown): number {
  if (value === null || value === undefined) {
    return 0;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }
  if (typeof value === 'bigint') {
    return Number(value);
  }
  if (typeof value !== 'string') {
    return 0;
  }
  const normalized: string = value
    .trim()
    .replace(/[R$\s]/gi, '')
    .replace(/%/g, '');
  if (!normalized) {
    return 0;
  }
  if (normalized.includes(',') && normalized.includes('.')) {
    if (normalized.lastIndexOf(',') > normalized.lastIndexOf('.')) {
      return Number(normalized.replace(/\./g, '').replace(',', '.')) || 0;
    }
    return Number(normalized.replace(/,/g, '')) || 0;
  }
  if (normalized.includes(',')) {
    const parts: string[] = normalized.split(',');
    if (parts.length === 2 && parts[1].length <= 2) {
      return Number(`${parts[0].replace(/\./g, '')}.${parts[1]}`) || 0;
    }
    return Number(normalized.replace(/,/g, '')) || 0;
  }
  if ((normalized.match(/\./g) || []).length > 1) {
    return Number(normalized.replace(/\./g, '')) || 0;
  }
  const parsed: number = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}

function formatWithBrazilianLocale(value: unknown, decimals: number): string {
  const formatter: Intl.NumberFormat = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return formatter.format(parseLocaleNumber(value));
}

/** Formats a number using the Brazilian convention: `1.439.704,65`. */
export function formatAppNumber(value: unknown, decimals: number = 2): string {
  return formatWithBrazilianLocale(value, decimals);
}

/** Formats a monetary number using the Brazilian convention without adding a currency symbol. */
export function formatAppCurrency(value: unknown, decimals: number = 2): string {
  return formatWithBrazilianLocale(value, decimals);
}

/**
 * @deprecated Prefer `formatAppNumber` or `formatAppCurrency`.
 */
export function formatLocaleNumber(value: unknown, config: unknown, decimals: number = 2, currency: boolean = false): string {
  void config;
  void currency;
  return formatWithBrazilianLocale(value, decimals);
}
